import { useEffect, useState } from "react";

interface TopicFilterProps {
  keyword: string;
  category: string;
  categories: { id: string; name: string; icon: string }[];
  counts: Record<string, number>;
  total: number;
  onKeywordChange: (value: string) => void;
  onSubmit: () => void;
  onCategoryChange: (id: string) => void;
  onReset: () => void;
}

export default function TopicFilter({
  keyword,
  category,
  categories,
  counts,
  total,
  onKeywordChange,
  onSubmit,
  onCategoryChange,
  onReset,
}: TopicFilterProps) {
  const [draft, setDraft] = useState(keyword);

  useEffect(() => {
    setDraft(keyword);
  }, [keyword]);

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <form
        className="flex flex-col gap-2 sm:flex-row sm:items-center"
        onSubmit={(e) => {
          e.preventDefault();
          onKeywordChange(draft);
          onSubmit();
        }}
        role="search"
      >
        <div className="flex flex-1 items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3">
          <i className="ri-search-line text-base text-foreground-400" />
          <input
            type="search"
            name="q"
            value={draft}
            onChange={(e) => {
              setDraft(e.target.value);
              onKeywordChange(e.target.value);
            }}
            placeholder="输入话题关键词，例如「改词」「退款」「剪辑」"
            aria-label="搜索话题关键词"
            className="min-w-0 flex-1 bg-transparent py-2.5 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
          />
        </div>
        <button
          type="submit"
          className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
        >
          搜索档案
        </button>
      </form>

      <div className="mt-4 flex flex-wrap items-center gap-2">
        <button
          type="button"
          onClick={() => onCategoryChange("all")}
          className={`cursor-pointer whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs transition-colors ${
            category === "all"
              ? "bg-primary-500 text-background-50"
              : "bg-secondary-100 text-secondary-900 hover:bg-secondary-200"
          }`}
        >
          全部 · {total}
        </button>
        {categories.map((cat) => (
          <button
            key={cat.id}
            type="button"
            onClick={() => onCategoryChange(cat.id)}
            className={`inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs transition-colors ${
              category === cat.id
                ? "bg-primary-500 text-background-50"
                : "bg-secondary-100 text-secondary-900 hover:bg-secondary-200"
            }`}
          >
            <i className={`${cat.icon} text-sm`} />
            {cat.name} · {counts[cat.id] ?? 0}
          </button>
        ))}
        {category !== "all" || keyword ? (
          <button
            type="button"
            onClick={onReset}
            className="inline-flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-full border border-background-300 px-3.5 py-1.5 text-xs text-foreground-600 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            <i className="ri-close-line text-sm" />
            清除筛选
          </button>
        ) : null}
      </div>
    </div>
  );
}